// A navbar fixa quebra em duas linhas em tela estreita e a altura varia com o menu
// do usuário: medir e publicar em `--gkg-ui-navbar-h` (padding-top do body).

const RAIZ = document.documentElement;

function medir() {
  const navbar = document.querySelector("#header .navbar");
  if (!navbar) return;

  RAIZ.style.setProperty("--gkg-ui-navbar-h", `${navbar.offsetHeight}px`);
}

function observar() {
  const navbar = document.querySelector("#header .navbar");
  if (!navbar || navbar.dataset.alturaObservada) return;

  navbar.dataset.alturaObservada = "true";
  new ResizeObserver(medir).observe(navbar);
  medir();
}

document.addEventListener("turbo:load", observar);
document.addEventListener("DOMContentLoaded", observar);

observar();
